import { createLoadingOverlay } from "@/v2/utils/loading-overlay.js";

/**
 * The one page-wide loading veil (#111741). Shared on `window` (like window.EventBus)
 * because a page can load several bundles that each contain this module, and the
 * veil is a single body class. Every caller — the http mixin's request counter and
 * any component that used to toggle `body.loading` by hand — must go through here,
 * otherwise a raw classList.remove("loading") can drop the veil while a coordinated
 * request is still in flight.
 */
export function pageLoadingOverlay() {
    if (!window.__boLoadingOverlay) {
        window.__boLoadingOverlay = createLoadingOverlay({
            apply: () => {
                document.body.classList.add("loading");
            },
            clear: () => {
                document.body.classList.remove("loading");
            },
            delayMs: 400,
        });
        window.__boActiveRequests = 0;
    }
    return window.__boLoadingOverlay;
}

export function syncPageBusyFlag(overlay = pageLoadingOverlay()) {
    // session-idle.js reads this so a deferred read still counts as "page busy"
    if (overlay.busy()) {
        document.body.dataset.boBusy = "1";
    } else {
        delete document.body.dataset.boBusy;
    }
}

/** Immediate veil for explicit callers (login flows, exports); pairs with hidePageLoading(). */
export function showPageLoading() {
    const overlay = pageLoadingOverlay();
    overlay.show("direct", { immediate: true });
    syncPageBusyFlag(overlay);
}

/** Ends an explicit veil without touching a request-counter-owned one. */
export function hidePageLoading() {
    const overlay = pageLoadingOverlay();
    overlay.hide("direct");
    syncPageBusyFlag(overlay);
}
